import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Panel, Button, Col, Row, HelpBlock } from 'react-bootstrap';
import { Input, FormActions, Select } from '../../common/components/formControls';
import TermsDropdownList from '../terms/DropdownList';
import CentersDropdownList from '../centers/DropdownList';
import { withTranslation } from 'react-i18next';
import ui from '../../common/services/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';

import { submitMode } from '.';

const Filter = ({ handleSubmit, onSubmit, onReset, initialize, loading, grades, paymentTypes, enableAutoEnrolment, t }) => {
	const handleReset = () => {
		initialize({});
		onReset();
	};
	return (
		<Panel>
			<Panel.Heading><FontAwesomeIcon icon={faFilter} />{t('Common_Filter')}</Panel.Heading>
			<Panel.Body>
				<form onSubmit={handleSubmit}>
					<Row>
						<Col sm={6}>
							<Field name='parent' component={Input} type='text' label={t('PaymentHistory_Parent')} />
						</Col>
						<Col sm={6}>
							<Field name='child' component={Input} type='text' label={t('PaymentHistory_Child')} />
						</Col>
					</Row>
					<Row>
						<Col sm={6}>
							<CentersDropdownList render='field' name='centerId' label={t('PaymentHistory_Center')} />
						</Col>
						<Col sm={6}>
							<TermsDropdownList render='field' name='termId' label={t('PaymentHistory_Term')} />
						</Col>
					</Row>
					<Row>
						<Col sm={6}>
							<Select name='gradeId' data={grades} label={t('ReportChildren_Grade')} />
						</Col>
						<Col sm={6}>
							<Select name='weekDay' data={Object.keys(ui.days).filter(key => Number(key) > 0).map(key => ({ id: key, displayName: t(ui.days[key]) }))} label={t('ReportChildren_WeekDay')} />
						</Col>
					</Row>
					<Row>
						<Col sm={6}>
							<Field name='city' component={Input} type='text' label={t('PaymentHistory_City')} />
						</Col>
						<Col sm={6}>
							<Select name='paymentType' label={t('PaymentHistory_PaymentType')} data={paymentTypes} />
						</Col>
					</Row>
					{enableAutoEnrolment && <Row>
						<Col sm={6}>
							<Field name='isAutoEnrolment' component={Input} componentClass='select' label={t('Enrolment_IsAutoEnrolment')}>
								<option value={''}>{t('Common_All')}</option>
								<option value={true}>{t('Common_Yes')}</option>
								<option value={false}>{t('Common_No')}</option>
							</Field>
						</Col>
					</Row>}
					<FormActions>
						<Button onClick={handleSubmit(values => onSubmit({ ...values }, submitMode.LIST))} disabled={loading} bsStyle='primary'>{t('Common_Filter')}</Button>
						<Button onClick={handleSubmit(values => onSubmit({ ...values }, submitMode.EXCEL))} disabled={loading} bsStyle='warning'>{t('Common_ExportToExcel')}</Button>
						<Button onClick={handleSubmit(values => onSubmit({ ...values }, submitMode.PDFBADGES))} disabled={loading} bsStyle='warning'>{t('Children_GenerateBadges')}</Button>
						<Button disabled={loading} onClick={handleReset}>{t('Common_Reset')}</Button>
					</FormActions>
					<HelpBlock>{t('Common_ExportHelpText')}</HelpBlock>
				</form>
			</Panel.Body>
		</Panel>
	);
};

Filter.propTypes = {
	onSubmit: PropTypes.func.isRequired
};

export default reduxForm({ form: 'enrolmentsFilter' })(withTranslation()(Filter));